import React, { useContext } from 'react';
import { useSearchParams } from 'react-router';
import CardView from '@/pages/login/components/Card/cardView';
import LoginForm from '@/pages/login/components/LoginForm/loginForm';
import McpConsent from '@/pages/login/components/McpConsent/McpConsent';
import Welcometext from '@/pages/login/components/WelcomeText/welcometext';
import { AuthContext } from '@/common/contexts/authContext';
import { LoginWrapper, Wrapper } from './Login.styled';

const LoginPage = () => {
	const [searchParams] = useSearchParams();
	const { authUser } = useContext(AuthContext);
	const isMcpReturn = Boolean(searchParams.get('mcp_request'));

	return (
		<Wrapper>
			<CardView />
			<LoginWrapper>
				<Welcometext />
				{isMcpReturn && authUser ? (
					<McpConsent />
				) : (
					<LoginForm isMcpReturn={isMcpReturn} />
				)}
			</LoginWrapper>
		</Wrapper>
	);
};

export default LoginPage;
